import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOrTiny,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonButton,
  SkeletonPillShape,
} from '@xing-com/skeleton';
import {
  scale150,
  scale190,
  scale230,
  scale270,
  spaceL,
  spaceM,
  spaceS,
  spaceXS,
} from '@xing-com/tokens';

type MyContactsListSkeletonContainerProps = {
  noMargin?: boolean;
};

const MyContactsListSkeletonContainer = styled.div<MyContactsListSkeletonContainerProps>`
  ${(props) =>
    props.noMargin
      ? `
        margin-top: ${spaceL};
      `
      : `
    margin-top: ${scale190};

    @media ${mediaConfined} {
      margin-top: ${scale230};
    }

    @media ${mediaWideNavless} {
      margin-top: 0;
    }
  `}
`;

const ContactSkeletonContainer = styled.div`
  display: flex;
  gap: ${spaceM};
  margin-bottom: ${spaceM};
  padding: ${spaceL} 0;

  @media ${mediaWideNavless} {
    padding: ${spaceL} ${spaceXS};
  }
`;

const ContactSkeletonInfoContainer = styled.div`
  flex: 1;

  @media ${mediaConfined} {
    padding: ${spaceS};
  }
`;

const ContactSkeletonInfoBodyCopy = styled(SkeletonBodyCopy)`
  margin-bottom: ${spaceS};
  max-width: ${scale270};
`;

const ContactSkeletonButtonsContainer = styled.div`
  display: flex;
  gap: ${spaceM};

  @media ${mediaSmallOrTiny} {
    flex-direction: column;
  }

  @media ${mediaConfined} {
    padding: ${spaceS};
  }
`;

const ContactSkeletonButton = styled(SkeletonButton)`
  width: ${scale270};

  @media ${mediaSmallOrTiny} {
    height: ${scale150};
    width: ${scale150};
  }
`;

const ContactSkeletonPillShape = styled(SkeletonPillShape)`
  margin-top: ${spaceS};
`;

export const Styled = {
  MyContactsListSkeletonContainer,
  ContactSkeletonContainer,
  ContactSkeletonInfoContainer,
  ContactSkeletonInfoBodyCopy,
  ContactSkeletonButtonsContainer,
  ContactSkeletonButton,
  ContactSkeletonPillShape,
};
